import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import API_END_POINTS from '../../../core/constants/apiEndPoints';
import { BehaviorSubject, Observable } from 'rxjs';
import { User, UsersResponse } from '../../types/User';

const { USERS } = API_END_POINTS;

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private http = inject(HttpClient);

  private currentUser$ = new BehaviorSubject<User | null>(null);
  readonly user$ = this.currentUser$.asObservable();

  getUsers(): Observable<UsersResponse> {
    return this.http.get<UsersResponse>(USERS);
  }

  addUser(data: User): Observable<UsersResponse> {
    return this.http.post<UsersResponse>(USERS, data);
  }
  
  fetchCurrentUser(): Observable<{ data: User }> {
    return this.http.get<{ data: User }>(API_END_POINTS.USER.FETCH_CURRENT);
  }

  public set user(v: User) {
    this.currentUser$.next(v);
  }

  
  public get user() :  User | null {
    return this.currentUser$.value;
  }
  
}
